import React from 'react'

import {
  Button,
  Divider,
  IconButton,
  InputAdornment,
  Link,
  List,
  ListItem,
  Popover,
  TextField,
  Typography,
  withStyles
} from '@material-ui/core'

import ProfileIcon from '@material-ui/icons/PersonRounded'
import SearchIcon from '@material-ui/icons/Search'

import Organizations from './OrganizationsList'
import SelectedOrganization from './SelectedOrganization'

import styles from './styles'

const normalize = value =>
  value
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

const OrganizationsMenu = ({
  classes,
  organizations,
  currentOrganization,
  currentUser,
  router
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [filter, setFilter] = React.useState('')

  const open = !!anchorEl

  const handleOpen = event => setAnchorEl(event.currentTarget)

  const handleClose = () => {
    setAnchorEl(null)
    setFilter('')
  }

  const filteredOrganizations = React.useMemo(() => {
    const term = normalize(filter.trim())
    if (!term) return organizations
    return organizations.filter(org => normalize(org.name).includes(term))
  }, [organizations, filter])

  return (
    <div data-intercom-target='organizations'>
      <IconButton
        className={classes.Navbar__Icon}
        aria-owns={open ? 'render-props-popover' : null}
        aria-haspopup='true'
        variant='contained'
        name='organization-menu'
        onClick={handleOpen}
      >
        <ProfileIcon />
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        marginThreshold={8}
        classes={{ paper: classes.Popover__List }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div className={classes.organization__header}>
          <Typography className={classes.organization__label} >
            {I18n.t('v4/organization.show.account')} {currentUser.email}
          </Typography>
        </div>

        {
          !_.isEmpty(currentOrganization) &&
          <SelectedOrganization
            selected={currentOrganization}
            currentUser={currentUser}
            router={router}
          />
        }

        {organizations.length > 5 && (
          <div className={classes.organizationsMenu__search}>
            <TextField
              fullWidth
              variant='outlined'
              size='small'
              margin='dense'
              value={filter}
              onChange={event => setFilter(event.target.value)}
              placeholder={I18n.t('v4/organization.actions.search_placeholder')}
              inputProps={{ 'data-testid': 'organizationsMenu__search' }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon fontSize='small' />
                  </InputAdornment>
                )
              }}
            />
          </div>
        )}

        <List className={classes.organizationsMenu__list}>
          {filteredOrganizations.length > 0 ? (
            <Organizations
              organizations={filteredOrganizations}
              router={router}
            />
          ) : (
            <ListItem className={classes.organizationsMenu__empty}>
              <Typography variant='caption'>
                {I18n.t('v4/organization.actions.search_empty')}
              </Typography>
            </ListItem>
          )}
        </List>
        <ListItem
          className={classes.organizationsMenu__footer}
        >
          <Button
            data-intercom-target='user_management'
            variant='outlined'
            color='secondary'
            className={classes.organizationsMenu__button}
            onClick={() => router.visit('account/edit')}
            data-testid='btnOrganizationsManage'
          >
            {I18n.t('v4/organization.actions.area')}
          </Button>

          <Button
            variant='outlined'
            className={classes.organizationsMenu__button}
            onClick={() => location.replace('/users/sign_out')}
            data-testid='btnLogout'
          >
            {I18n.t('actions.exit')}
          </Button>
        </ListItem>

        <Divider />
        <div className={classes.organizationsMenu_terms}>
          <Link
            href={`/v5/privacy_policies`}
            target='_blank'
            underline='always'
            className={classes.organizationsMenu_termsLink}
          >
            <Typography variant="caption">
              {I18n.t('v4/users.privacy_policies')}
            </Typography>
          </Link>

          <Link
            href={`/v5/terms`}
            target='_blank'
            underline='always'
            className={classes.organizationsMenu_termsLink}
          >
            <Typography variant="caption">
              {I18n.t('v4/users.terms_of_use')}
            </Typography>
          </Link>
        </div>

      </Popover>
    </div>
  )
}

export default withStyles(styles)(OrganizationsMenu)
